import React, {
  Component,
  useState,
  useContext,
  useEffect,
  useRef,
} from "react";
import {
  Button,
  Row,
  Modal,
  Form,
  Container,
  Col,
  InputGroup,
} from "react-bootstrap";
import { useParams } from "react-router-dom";
import { StorefrontApi } from "../../apiclient";
import { apiConfig } from "../../config";
import toast, { LoaderIcon, Toaster } from "react-hot-toast";
import "react-quill/dist/quill.snow.css";
import "./PublicStorefront.css";
import {
  GiftCardDetailViewModel,
  StorefrontOrderViewModel,
  StorefrontSettingsViewModel,
} from "../../apiclient/models";
//import { escape, unescape } from "lodash";
// import VideoRecorderModal from "../public_customer/VideoRecorderModal";
import PublicStorefrontAddToCartComponent from "./PublicStorefrontAddToCartComponent";
import PublicStorefrontGiftCardDetailsComponent from "./PublicStorefrontGiftCardDetailsComponent";
import PublicStorefrontPaymentComponent from "./PublicStorefrontPaymentComponent";
import PublicStorefrontCheckBalanceComponent from "./PublicStorefrontCheckBalanceComponent";
import { useNavigate } from "react-router";
import PublicStorefrontComingSoonComponent from "./PublicStorefrontComingSoonComponent";
import { Helmet } from "react-helmet";
import { PlatformFeeAppliesLink } from "./PlatformFee";

//import "./assets.css";
const PublicStorefrontCheckoutPage = () => {
  const [showCheckBalanceForm, setShowCheckBalanceForm] = useState(false);
  const [showPage, setShowPage] = useState("cart");
  const [selectedAmount, setSelectedAmount] = useState(0);
  const [model, setModel] = useState({} as StorefrontOrderViewModel);
  const [checkBalanceCode, setCheckBalanceCode] = useState("");
  const [validated, setValidated] = useState(false);
  const [showInvalidCodeError, setShowInvalidCodeError] = useState(false);
  const [giftCardModel, setGiftCardModel] = useState(
    {} as GiftCardDetailViewModel
  );
  const [settings, setSettings] = useState({} as StorefrontSettingsViewModel);
  const [customHeadScript, setCustomHeadScript] = useState("");
  const [refreshCount, setRefreshCount] = useState(0);
  //let { id } = useParams();

  let storefrontApi = new StorefrontApi(
    apiConfig.configuration,
    apiConfig.baseUrl
  );

  const navigate = useNavigate();

  const handleCheckBalanceSubmit = (event: any) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    setValidated(true);
    if (form.checkValidity() === true) {
      getGiftCardByCode();
    }
  };

  const handleCheckBalanceCodeChange = (event: any) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = event.target.name;
    setCheckBalanceCode(value);
  };

  const getGiftCardByCode = () => {
    if (checkBalanceCode) {
      storefrontApi
        .storefrontGetByCodeCodeGet(checkBalanceCode)
        .then((response) => {
          if (response.data) {
            setGiftCardModel(response.data);
            setShowInvalidCodeError(false);
            showBalancePageOnClick();
          } else {
            toast.error("Invalid code.");
            setShowInvalidCodeError(true);
          }
        })
        .catch((error: any) => {
          toast.error("An error occurred check code.");
        });
    }
  };

  const initOrderModel = () => {
    //var model = props.model as StorefrontOrderViewModel;
    storefrontApi
      .storefrontInitStorefrontOrderPost()
      .then((response) => {
        setModel(response.data!);
      })
      .catch((error: any) => { });
  };

  useEffect(() => {
    initOrderModel();
    fetchSettings();
    fetchCustomScript();
  }, []);

  const fetchCustomScript = () => {
    storefrontApi
      .storefrontGetCustomEmbedScriptGet()
      .then((response) => {
        var data = response.data;
        if (data) {
          setCustomHeadScript(data!);
        }
      })
      .catch((error: any) => { });
  };

  const fetchSettings = () => {
    storefrontApi
      .storefrontSettingsGet()
      .then((response) => {
        var data = response.data;
        if (data) {
          if (!data.isPublished) {
            data.hideCheckBalance = true;
            setShowPage("comingsoon");
          }

          setSettings(data);
        } else {
          // account not found
          navigate("/account-not-found");
        }
      })
      .catch((error: any) => {
        console.log("get error", error);
        navigate("/account-not-found");
      });
  };

  const checkBalanceOnClick = () => {
    setShowCheckBalanceForm(true);
  };

  const showDetailsPageOnClick = (amount: number, productName: string) => {
    setSelectedAmount(amount);
    setShowPage("details");
    setShowCheckBalanceForm(false);
    setModel((values: StorefrontOrderViewModel) => ({
      ...values,
      amount: amount,
      productName: productName,
    }));
  };

  const showCartPageOnClick = () => {
    setShowPage("cart");
    setShowCheckBalanceForm(false);
  };

  const showPaymentPageOnClick = (amount: number) => {
    setShowPage("payment");
    setShowCheckBalanceForm(false);
  };

  const onUpdated = (updatedModel: StorefrontOrderViewModel) => {
    if (updatedModel) {
      setModel(updatedModel);
      setRefreshCount(refreshCount + 1);
    }
  };

  const showBalancePageOnClick = () => {
    setShowPage("balance");
    setShowCheckBalanceForm(false);
  };

  const onNavigateToPage = (pageName: string) => {
    setShowPage(pageName);
    setShowCheckBalanceForm(false);
  };

  return (
    <React.Fragment>
      <div className="bg-surface-secondary">
        <div className="container py-10">
          <div className="row">
            <div className="col-lg-5 mx-auto">
              <div className="card shadow border-0 mb-10">
                <div className="card-body p-0">
                  <div className="p-2">
                    <img
                      alt=""
                      src={settings.headerImageUrl}
                      className="card-img fit-contain-maxh-300"
                    />
                  </div>
                  {settings && settings.description && (
                    <div
                      className="text-center p-2"
                      dangerouslySetInnerHTML={{
                        __html: settings.description!,
                      }}
                    />
                  )}
                  {showPage === "comingsoon" && (
                    <PublicStorefrontComingSoonComponent model={settings} />
                  )}
                  {showPage === "cart" && (
                    <PublicStorefrontAddToCartComponent
                      model={model}
                      onNavigateToPage={onNavigateToPage}
                      onUpdated={onUpdated}
                      onSelected={showDetailsPageOnClick}
                      refreshCount={refreshCount}
                    />
                  )}
                  {showPage === "balance" && (
                    <PublicStorefrontCheckBalanceComponent
                      onBack={showCartPageOnClick}
                      model={giftCardModel}
                      settings={settings}
                      refreshCount={refreshCount}
                    />
                  )}
                  {showPage === "details" && (
                    <PublicStorefrontGiftCardDetailsComponent
                      model={model}
                      settings={settings}
                      onNavigateToPage={onNavigateToPage}
                      onUpdated={onUpdated}
                      onSubmit={showPaymentPageOnClick}
                      amount={selectedAmount}
                      refreshCount={refreshCount}
                    />
                  )}
                  {showPage === "payment" && (
                    <PublicStorefrontPaymentComponent
                      settings={settings}
                      model={model}
                      onNavigateToPage={onNavigateToPage}
                      onUpdated={onUpdated}
                      onSubmit={showPaymentPageOnClick}
                      amount={selectedAmount}
                      refreshCount={refreshCount}
                    />
                  )}
                  {showPage !== "balance" &&
                    settings &&
                    !settings.hideCheckBalance && (
                      <div className="card-footer text-center">
                        {!showCheckBalanceForm ? (
                          <a
                            className="text-sm cursor-pointer"
                            onClick={checkBalanceOnClick}
                          >
                            {settings.translation?.checkoutPage?.checkYourGiftCardBalance}
                          </a>
                        ) : (
                          <Form
                            noValidate
                            validated={validated}
                            onSubmit={handleCheckBalanceSubmit}
                          >
                            <InputGroup className="mb-3">
                              <Form.Control
                                required
                                name="checkBalanceCode"
                                value={checkBalanceCode}
                                size="sm"
                                placeholder="Enter gift card code..."
                                aria-label="Enter gift card code..."
                                onChange={handleCheckBalanceCodeChange}
                              />
                              <Button
                                type="submit"
                                //onClick={showBalancePageOnClick}
                                size="sm"
                                variant="primary"
                                className="btn-custom"
                              >
                                {settings.translation?.checkoutPage?.checkBalance}
                              </Button>
                            </InputGroup>
                            {showInvalidCodeError && (
                              <div className="font-semibold text-danger text-sm text-start">
                                {settings.translation?.checkoutPage?.noGiftCardFound} '
                                {checkBalanceCode}'
                              </div>
                            )}
                          </Form>
                        )}
                      </div>
                    )}
                </div>
              </div>
              <PlatformFeeAppliesLink amount={settings.platformFee} currencyCode={settings.isoCurrencyCode} />
              {settings && !settings.hideWrappedBranding && (
                <footer className="">
                  <div className="container">
                    <a
                      target="_blank"
                      href="https://wrappedgiftcards.com?utm_source=branding&utm_medium=web"
                    >
                      <div className="row justify-content-center">
                        <div className="col-auto">
                          <img
                            src="/img/logos/wrapped-logo-grey.png"
                            className="h-10"
                            alt="..."
                          />
                        </div>
                      </div>
                      <div className="row justify-content-center text-center">
                        <div className="col-xl-9">
                          <p className="text-sm text-muted opacity-80">
                          {settings.translation?.checkoutPage?.wrappedTagLine}
                          </p>
                        </div>
                      </div>
                    </a>
                  </div>
                </footer>
              )}
            </div>
          </div>
        </div>
      </div>
      <Helmet>
        {model && model.accountId && (
          <link
            rel="stylesheet"
            href={`Storefront/gifttofriendstyle.css?accountId=${model.accountId}`}
          />
        )}
        {customHeadScript && (
          <script>{`
            document.head.innerHTML += \`${customHeadScript}\`;
          `}</script>
        )}
      </Helmet>
    </React.Fragment>
  );
};

export default PublicStorefrontCheckoutPage;
